import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickPurchaseComponent } from './quick-purchase.component';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoCoreModule } from 'app/services/transloco/transloco.http-loader';
import { DirectivesModule } from 'app/common/directives/directives.module';



@NgModule({
  declarations: [
    QuickPurchaseComponent
  ],
  imports: [
    CommonModule,
    KButtonModule,
    FontAwesomeModule,
    TranslocoCoreModule,
    DirectivesModule
  ],
  exports: [
    QuickPurchaseComponent
  ]
})
export class QuickPurchaseModule { }
